// ============================================
// TIPOCAMBIOWIDGET.JS — Tipo de cambio USD/MXN (Mercado)
// ============================================

import React, { useEffect, useState } from 'react';
import { API_BASE } from '../config/api';

const PP = "'Poppins', sans-serif";
const colores = { gris: '#4e5357', grisClaro: '#5e666e', verde: '#1D9E75', rojo: '#e05c5c', neutro: '#9aa0a6', fondo: '#f8fafc', borde: '#eef2f6' };

function formatMXN(n) {
  if (n == null || !Number.isFinite(n)) return '—';
  return n.toLocaleString('es-MX', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
}

function formatHora(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: false });
  } catch {
    return '';
  }
}

function TipoCambioWidget() {
  const [estado, setEstado] = useState({ cargando: true, error: null, data: null, oculto: false });

  useEffect(() => {
    let activo = true;
    const cargar = async () => {
      try {
        const r = await fetch(`${API_BASE}/api/tipo-cambio`);
        if (r.status === 503) {
          if (activo) setEstado({ cargando: false, error: null, data: null, oculto: true });
          return;
        }
        const j = await r.json();
        if (!activo) return;
        if (!j.ok) {
          setEstado({ cargando: false, error: j.error || 'Error', data: null, oculto: false });
          return;
        }
        setEstado({ cargando: false, error: null, data: j, oculto: false });
      } catch (e) {
        if (activo) setEstado({ cargando: false, error: 'Sin conexión', data: null, oculto: false });
      }
    };
    cargar();
    return () => { activo = false; };
  }, []);

  if (estado.oculto) return null;

  const contenedor = {
    padding: '12px 20px',
    background: colores.fondo,
    borderBottom: `1px solid ${colores.borde}`,
    fontFamily: PP,
    flexShrink: 0,
  };

  if (estado.cargando) {
    return (
      <div style={contenedor}>
        <div style={{ fontSize: '10px', fontWeight: 600, color: colores.grisClaro, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' }}>Tipo de cambio</div>
        <div style={{ fontSize: '12px', color: colores.grisClaro }}>Cargando…</div>
      </div>
    );
  }

  if (estado.error || !estado.data) {
    return (
      <div style={contenedor}>
        <div style={{ fontSize: '10px', fontWeight: 600, color: colores.grisClaro, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' }}>Tipo de cambio</div>
        <div style={{ fontSize: '12px', color: colores.grisClaro }}>No disponible</div>
      </div>
    );
  }

  const { actual, variacion, tendencia, fechaActualizacion } = estado.data;
  const flecha = tendencia === 'subio' ? '↑' : tendencia === 'bajo' ? '↓' : '→';
  const colorTend = tendencia === 'subio' ? colores.verde : tendencia === 'bajo' ? colores.rojo : colores.neutro;
  const varTexto = variacion == null ? '' : `${variacion > 0 ? '+' : ''}${variacion.toFixed(4)}`;

  return (
    <div style={contenedor}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
        <div style={{ fontSize: '10px', fontWeight: 600, color: colores.grisClaro, textTransform: 'uppercase', letterSpacing: '0.06em' }}>USD / MXN</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', fontWeight: 600, color: colorTend }}>
          <span style={{ fontSize: '13px', lineHeight: 1 }}>{flecha}</span>
          <span>{varTexto}</span>
        </div>
      </div>
      <div style={{ fontSize: '15px', fontWeight: 700, color: colores.gris, letterSpacing: '0.2px' }}>
        1 USD = <span style={{ color: '#2f5f9e' }}>${formatMXN(actual)}</span> MXN
      </div>
      <div style={{ fontSize: '10px', color: colores.grisClaro, marginTop: '4px' }}>
        Mercado · actualizado {formatHora(fechaActualizacion)}
      </div>
    </div>
  );
}

export default TipoCambioWidget;
